// objectFitPolyfill();
(function($) {
  let $body = $('body');
  let $gotop = $('.gotop');
  let menuOpenSpeed = 300;
  let isMobile = false;
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

  // IE關閉smooth scroll
  if(navigator.userAgent.match(/Trident\/7\./)) {
    document.body.addEventListener("mousewheel", function() {
      event.preventDefault();
      let wd = event.wheelDelta;
      let csp = window.pageYOffset;
      window.scrollTo(0, csp - wd);
    });
  }
  $('.nav-toggle').click(function(event) {
    $body.toggleClass('nav-open');
    return false;
  });
  $('.menu li').has('ul').addClass('has-child');
  $('.menu li.has-child').hover(function(event) {
    if (!isMobile) {
      $(this).addClass('open');
    }
  }, function() {
    if (!isMobile) {
      $(this).removeClass('open');
    }
  });
  $('.menu li.has-child > a').on('click', function(event) {
    if (isMobile) {
      $(this).parent().toggleClass('open');
      $(this).parent().siblings('li').removeClass('open');
      if (!$(this).parent().hasClass('open')) {
        $(this).siblings('ul').find('li').removeClass('open');
      }
      return false;
    }
  });
  $('.menu a').on('click', function(e) {
    if ($(this).attr('href').includes('#')) {
      $body.removeClass('nav-open');
      $(this).parents('li').removeClass('open');
    }
  });
  $('.js-scroll').on('click', function (event) {
    var t = $(this).attr('href');
    if ($('.js-toggle').length && $('.js-toggle').is(':visible')) {
      $('.toggle-target').not(t).removeClass('active');
      $(t).addClass('active');
    } else {
      var pos = $(t).offset().top;
      $('html,body').stop().animate({
        scrollTop: pos - $('.site-title').outerHeight()
      }, 400, function () {
        // $body.addClass('header-hide');
      });
    }
    $body.removeClass('nav-open');
    return false;
  });

  if ($('.js-open-dialog').length) {
    $('.js-open-dialog').magnificPopup({
      type: 'inline',
  
      fixedContentPos: false,
      fixedBgPos: true,
      showCloseBtn: false,
  
      overflowY: 'auto',
  
      closeBtnInside: true,
      preloader: false,
      
      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-zoom-in'
    });
    if ($('.js-close-dialog').length) {
      $(document).on('click', '.js-close-dialog', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
      });
    }
  }
  if ($('.index1-banner-slider').length) {
    $('.index1-banner-slider').slick({
      autoplay: true,
      adaptiveHeight: true,
      arrows: true,
      dots: false,
    });
  }
  if ($('.index2-banner-slider').length) {
    var $el = $('.index2-banner');
    $(window).on('scroll resize', function(event) {
      if ($('.nav-toggle').is(':hidden')) {
        var listTopPos = $('.index2-event').offset().top - $('.site-title').outerHeight();
        var listPos = $('.index2-event').offset().top + $('.index2-event').outerHeight() - $el.outerHeight(true) - $('.site-title').outerHeight();
        if ($(window).scrollTop() <= listPos &&  $(window).scrollTop() >= listTopPos) {
          var txtTop = $(window).scrollTop() - listTopPos;
        } else if ($(window).scrollTop() < listTopPos) {
          var txtTop = 0;
        } else if ($(window).scrollTop() > listTopPos) {
          var txtTop = $('.index2-event').outerHeight() - $el.outerHeight(true);
        }
        $el.css('top', txtTop);
      } else {
        $el.css('top', 0);
      }
    }).scroll();
    $('.index2-banner-slider').slick({
      autoplay: true,
      adaptiveHeight: true,
      arrows: false,
      dots: true,
    });
  }
  if ($('.js-toggle').length) {
    $('.js-toggle').on('click', function(e) {
      var t = $(this).data('target');
      $('.toggle-target').not(t).removeClass('active');
      $(t).toggleClass('active');
      return false;
    });
  }
  if ($('.index1-gift-slider').length) {
    $('.index1-gift-slider').slick({
      arrows: true,
      dots: true,
      speed: 300,
      appendArrows: $('.index1-gift-slider-control'),
      appendDots: $('.index1-gift-slider-page'),
      // swipeToSlide: true,
      // infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }]
    }).on('setPosition', function(event, slick){
      if (slick.$dots.children('li').length>1) {
        $('.index1-gift-slider-control').removeClass('hide');
        $('.index1-gift-slider-page .total').text(slick.$dots.children('li').length);
        $('.index1-gift-slider-page .current').text(slick.$dots.children('li.slick-active').find('button').text());
      } else {
        $('.index1-gift-slider-control').addClass('hide');
      }
    });
  }
  if ($('.index2-gift-slider').length) {
    $('.index2-gift-slider').slick({
      arrows: true,
      dots: true,
      speed: 300,
      appendArrows: $('.index2-gift-slider-control'),
      appendDots: $('.index2-gift-slider-page'),
      // swipeToSlide: true,
      // infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1360,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
    }).on('setPosition', function(event, slick){
      if (slick.$dots.children('li').length>1) {
        $('.index2-gift-slider-control').removeClass('hide');
        $('.index2-gift-slider-page .total').text(slick.$dots.children('li').length);
        $('.index2-gift-slider-page .current').text(slick.$dots.children('li.slick-active').find('button').text());
      } else {
        $('.index2-gift-slider-control').addClass('hide');
      }
    });
  }
  function accordionToggle($parent, options={onlyOneOpen:false, openScroll: false}) {    
    $parent.toggleClass('accordion-active')
    if (options.onlyOneOpen) {
      $parent.siblings('.accordion-item').removeClass('accordion-active').children('.accordion-content').hide();
    }
    if ($parent.hasClass('accordion-active')) {
      $parent.find('.accordion-content').stop().slideDown()
      // $parent.find('.accordion-content').stop().slideDown(function(e) {
      //   if (options.openScroll && $parent.hasClass('accordion-active')) {
      //     $('html,body').stop().animate({
      //       scrollTop: $parent.offset().top - $('.site-title').outerHeight()
      //     }, 400);
      //   }
      // });
    } else {
      $parent.find('.accordion-content').stop().slideUp()
    }
    // if ($btn.parent('.accordion-item').hasClass('active') && !$btn.siblings('.accordion-content').find('.accordion-item:first-child').hasClass('active')) {
    //   $btn.siblings('.accordion-content').find('.accordion-item:first-child .js-accordion-toggle').trigger('click');
    //   return false;
    // }
  }
  if ($('.js-accordion-toggle').length) {
    $('.js-accordion-toggle').on('click', function(e) {
      var $parent = $(this).parent('.accordion-item');
      accordionToggle($parent, {onlyOneOpen:false, openScroll: true});
    });
    accordionToggle($('.accordion-wrap[data-active]').children('.accordion-item').eq($('.accordion-wrap[data-active]').data('active')-1), {onlyOneOpen:false, openScroll: false});
  }

  if ($('.js-tab-nav').length) {
    $('.js-tab-nav a').on('click', function(e) {
      var t = $(this).attr('href');
      $(this).parent('li').addClass('tab-active').siblings('li').removeClass('tab-active');
      $(t).addClass('tab-active').siblings('.tab-content').removeClass('tab-active');

      $(t).find('.accordion-content').show();
      return false;
    });
    $('.js-tab-nav li').eq(0).find('a').trigger('click');
  }

  $(document).on('click', function(e){
    if($(e.target).parents('.nav').length==0){
      $body.removeClass('nav-open');
    }
    if($(e.target).parents('.menu').length==0){
      $('.menu li.has-child').removeClass('open');
    }
    if($(e.target).parents('.msg-box').length==0 || $(e.target).hasClass('msg-box-close') || $(e.target).parents('.msg-box-close').length > 0){
      $body.removeClass('msg-box-open');
      $('.msg-box').removeClass('show');
    }
  }).on('click', '.msg-box-toggle', function(event) {
    var t = $(this).attr('href');
    $('.msg-box').removeClass('show');
    $(t).addClass('show');
    $body.addClass('msg-box-open');
    return false;
  });

  function resizedw(){
    $('.main').css('min-height', $(window).height() - $('.footer').outerHeight());
    $('.win-h').height($(window).height());
    if ($('.js-tab-nav').length) {
      if ($('.js-tab-nav').is(':hidden')) {
        var t = $('.js-tab-nav li.tab-active a').attr('href');
        $(t).removeClass('accordion-active');
        accordionToggle($(t), {onlyOneOpen:true, openScroll: false})
        $('.accordion-item').removeClass('tab-content');
        $('.accordion-content').addClass('tab-active');
        $('.js-tab-nav li').removeClass('tab-active');
      } else if ($('.accordion-active').length) {
        $('.accordion-item').addClass('tab-content');
        var accordionActiveId = $('.tab-content.accordion-active').eq(0).attr('id');
        $('.js-tab-nav a[href="#'+accordionActiveId+'"]').trigger('click');
        $('.tab-content').removeClass('accordion-active');
      }
    }
  }
  var doit;
  $(window).on('resize', function(event) {
    clearTimeout(doit);
    doit = setTimeout(resizedw, 100);
  }).resize();
  $(window).on('load', function () {
    resizedw();
  });
  $gotop.click(function(event) {
    $('html,body').stop().animate({
      scrollTop: 0
    }, 400);
    return false;
  });
  
  $(window).on('scroll', function(event) {
    if ($(window).scrollTop() > 30) {
      $body.addClass('header-fixed');
    } else {
      $body.removeClass('header-fixed');
    }
  }).scroll();

  let lastScrollTop = $(window).scrollTop();
  let st = $(window).scrollTop();
  $(window).on('load', function() {
    $('.anime').each(function () {
      let currSect = $(this);
      $('.anime').each(function () {
        let currSect = $(this);
        if (currSect.offset().top - $(window).height() <= st) {
          currSect.addClass("anime-run");
        }
      });
    });
  });
  $(window).on('scroll', function(event) {
    st = $(window).scrollTop();
    if (st > lastScrollTop){
      $('.anime').each(function () {
        let currSect = $(this);
        if (currSect.offset().top - $(window).height()*0.75 <= st && currSect.offset().top + $(window).height()*0.75 > st) {
          currSect.addClass("anime-run");
        }
      });
    } else {
      $('.anime').each(function () {
        let currSect = $(this);
        if (currSect.offset().top - $(window).height()*0.5 <= st && currSect.offset().top > st) {
          currSect.addClass("anime-run");
        }
      });
    }
    lastScrollTop = st;
  });
})($)
